import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faCircleUser } from "@fortawesome/free-solid-svg-icons";
import Sidebar from "../Components/Sidebar";
import { apiConnector } from "../../services/apiConnector";
import { url } from "../../services/api";
import EmployeeCompo from "../Components/EmployeeCompo";
import Currency from "../Components/Currency";
import Country from "../Components/Country";
import QualityCategory from "../Components/QualityCategory";
import Destination from "../Components/Destination";
import TimeZone from "../Components/TimeZone";
import PaymentCycle from "../Components/PaymentCycle";
import EmployeeGroupCompo from "../Components/EmployeeGroupCompo";
// import { Skeleton, Grid, Box, Button } from '@mui/material';
import {
  Box,
  Grid,
  Skeleton,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton,
  Slide
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import toast from "react-hot-toast";
import { ThreeDots } from 'react-loader-spinner'
import {
  getMfaStatus,
  disableMfa,
  startMfaSetup,
  verifyMfaSetup,
  regenerateMfaRecoveryCodes,
  logoutemployee,
} from "../../features/employeeSlice";


const Customer = () => {
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState([]);



  const employee = useSelector((state) => state.employee);
  const dispatch = useDispatch();
  const [mfaStatusLoading, setMfaStatusLoading] = useState(false);
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [mfaEnabledAt, setMfaEnabledAt] = useState(null);
  const [mfaDisableOpen, setMfaDisableOpen] = useState(false);
  const [mfaPassword, setMfaPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [mfaDisableLoading, setMfaDisableLoading] = useState(false);
  const [showMfaPassword, setShowMfaPassword] = useState(false);
  const [mfaSetupOpen, setMfaSetupOpen] = useState(false);
  const [mfaSetupLoading, setMfaSetupLoading] = useState(false);
  const [mfaSetupVerifyLoading, setMfaSetupVerifyLoading] = useState(false);
  const [mfaSetupData, setMfaSetupData] = useState(null);
  const [mfaSetupCode, setMfaSetupCode] = useState('');
  const [mfaRecoveryStatus, setMfaRecoveryStatus] = useState({ total: 0, remaining: 0, used: 0 });
  const [recoveryCodesOpen, setRecoveryCodesOpen] = useState(false);
  const [plainRecoveryCodes, setPlainRecoveryCodes] = useState([]);
  const [mfaRecoveryDialogMessage, setMfaRecoveryDialogMessage] = useState('');
  const [mfaRegenerateOpen, setMfaRegenerateOpen] = useState(false);
  const [mfaRegeneratePassword, setMfaRegeneratePassword] = useState('');
  const [mfaRegenerateCode, setMfaRegenerateCode] = useState('');
  const [mfaRegenerateLoading, setMfaRegenerateLoading] = useState(false);
  const [showMfaRegeneratePassword, setShowMfaRegeneratePassword] = useState(false);


  const headers = {
    Authorization: `Bearer ${employee.token}`,
  };
  
  
  useEffect(() => {
    const params = {
      method: "GET",
      url: `${url}/api/employee/${employee._id}`,
      headers: headers,
    };

    apiConnector(params)
      .then((response) => {
        setMe(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const fetchMfaStatus = async () => {
      if (!employee?.token) {
        return;
      }

      setMfaStatusLoading(true);
      const action = await dispatch(getMfaStatus());

      if (getMfaStatus.fulfilled.match(action)) {
        setMfaEnabled(Boolean(action.payload?.mfaEnabled));
        setMfaEnabledAt(action.payload?.mfaEnabledAt || null);
        setMfaRecoveryStatus(action.payload?.recoveryCodes || { total: 0, remaining: 0, used: 0 });
      }

      setMfaStatusLoading(false);
    };

    fetchMfaStatus();
  }, [dispatch, employee?.token]);




    

    const [loadingg, setLoadingg] = useState(true);
  
    useEffect(() => {
      const timer = setTimeout(() => {
        setLoadingg(false);
      }, 1000);
  
      return () => clearTimeout(timer);
    }, []);
  


    const [open, setOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
 const [passLoader,setPassLoader]=useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setOpen(false);
  };

  const handleChangePassword = async () => {
 
    setPassLoader(true);
    if(!oldPassword || oldPassword.trim()===''){
      toast.error("Old Password must not be blank!");
      setPassLoader(false);
        return false;
    }
  
    if(!newPassword || newPassword.trim()===''  || newPassword.length <6){
      toast.error("New Password must be minimum 6 characters!");
      setPassLoader(false);
        return false;
    }

    if(newPassword!==confirmPassword){
        toast.error("New Passwords not matched!");
        setPassLoader(false);
        return false;
    }
 

    try{
      
      let response = await apiConnector({
      method: "POST",
      url: `${url}/api/changePassword`,
      bodyData: {
        oldPassword:oldPassword,
        newPassword:newPassword
      },
      headers: headers,
    });

    if(response.status===200){
      toast.success(`${response?.data?.message}`);
      handleClose();
    }

  }catch(error){
    toast.error(`${error?.response?.data?.message}`);
  }

  setPassLoader(false);


   
  };

  const togglePasswordVisibility = (setShowPassword) => {
    setShowPassword((show) => !show);
  };

  const handleMfaDisableClose = () => {
    setMfaDisableOpen(false);
    setMfaPassword('');
    setMfaCode('');
    setShowMfaPassword(false);
  };

  const handleMfaSetupClose = () => {
    if (mfaSetupVerifyLoading) {
      return;
    }

    setMfaSetupOpen(false);
    setMfaSetupCode('');
    setMfaSetupData(null);
  };

  const handleRecoveryCodesClose = () => {
    setRecoveryCodesOpen(false);
    setPlainRecoveryCodes([]);
    setMfaRecoveryDialogMessage('');
  };

  const handleMfaRegenerateClose = () => {
    if (mfaRegenerateLoading) {
      return;
    }

    setMfaRegenerateOpen(false);
    setMfaRegeneratePassword('');
    setMfaRegenerateCode('');
    setShowMfaRegeneratePassword(false);
  };

  const copyRecoveryCodes = async () => {
    const text = plainRecoveryCodes.join('\n');

    try {
      await navigator.clipboard.writeText(text);
      toast.success('Recovery codes copied');
    } catch (error) {
      toast.error('Could not copy recovery codes. Please copy them manually.');
    }
  };

  const handleStartMfaSetup = async () => {
    setMfaSetupLoading(true);
    const action = await dispatch(startMfaSetup({}));

    if (startMfaSetup.fulfilled.match(action)) {
      setMfaSetupData(action.payload);
      setMfaSetupCode('');
      setMfaSetupOpen(true);
    }

    setMfaSetupLoading(false);
  };

  const handleVerifyMfaSetup = async () => {
    if (!/^\d{6}$/.test(String(mfaSetupCode || '').trim())) {
      toast.error("Enter a valid 6-digit authenticator code");
      return;
    }

    setMfaSetupVerifyLoading(true);
    const action = await dispatch(verifyMfaSetup({
      code: mfaSetupCode.trim(),
    }));

    if (verifyMfaSetup.fulfilled.match(action)) {
      const codes = Array.isArray(action.payload?.recoveryCodes) ? action.payload.recoveryCodes : [];
      setMfaEnabled(true);
      setMfaEnabledAt(action.payload?.mfaEnabledAt || new Date().toISOString());
      setMfaRecoveryStatus({ total: codes.length, remaining: codes.length, used: 0 });
      setMfaSetupOpen(false);
      setMfaSetupCode('');
      setMfaSetupData(null);

      if (codes.length > 0) {
        setPlainRecoveryCodes(codes);
        setMfaRecoveryDialogMessage('Save these recovery codes now. They will not be shown again.');
        setRecoveryCodesOpen(true);
      }
    }

    setMfaSetupVerifyLoading(false);
  };

  const handleRegenerateRecoveryCodes = async () => {
    if (!mfaRegeneratePassword || mfaRegeneratePassword.trim() === '') {
      toast.error("Current password is required");
      return;
    }

    if (!/^\d{6}$/.test(String(mfaRegenerateCode || '').trim())) {
      toast.error("Enter a valid 6-digit authenticator code");
      return;
    }

    setMfaRegenerateLoading(true);
    const action = await dispatch(regenerateMfaRecoveryCodes({
      password: mfaRegeneratePassword,
      code: mfaRegenerateCode.trim(),
    }));

    if (regenerateMfaRecoveryCodes.fulfilled.match(action)) {
      const codes = Array.isArray(action.payload?.recoveryCodes) ? action.payload.recoveryCodes : [];
      setMfaRecoveryStatus({ total: codes.length, remaining: codes.length, used: 0 });
      setMfaRegenerateOpen(false);
      setMfaRegeneratePassword('');
      setMfaRegenerateCode('');
      setShowMfaRegeneratePassword(false);

      if (codes.length > 0) {
        setPlainRecoveryCodes(codes);
        setMfaRecoveryDialogMessage('Your old recovery codes are now invalid. Save these new codes now.');
        setRecoveryCodesOpen(true);
      }
    }

    setMfaRegenerateLoading(false);
  };

  const handleDisableMfa = async () => {
    if (!mfaPassword || mfaPassword.trim() === '') {
      toast.error("Current password is required");
      return;
    }

    if (!/^\d{6}$/.test(String(mfaCode || '').trim())) {
      toast.error("Enter a valid 6-digit authenticator code");
      return;
    }

    setMfaDisableLoading(true);
    const action = await dispatch(disableMfa({
      password: mfaPassword,
      code: mfaCode.trim(),
    }));

    if (disableMfa.fulfilled.match(action)) {
      setMfaEnabled(false);
      setMfaEnabledAt(null);
      handleMfaDisableClose();
      dispatch(logoutemployee());
      window.location.href = "/";
      return;
    }

    setMfaDisableLoading(false);
  };

  return (
    <Sidebar>
      <div className="container-fluid mb-50">
        {/* <!-- Page Heading --> */}
       
        <h1 className="h3 mb-4 text-gray-800">Setting</h1>
   

<br/> 
<br/> 






    <Paper
      elevation={8}
      sx={{
        width: '100%',
        padding: 2,
        borderRadius: 4,
        position: 'relative',
        backgroundColor: 'white', // Set background color to white
        '@media (min-width: 970px)': {
          width: '40%',
        },
        fontSize: '100%',
        '@media (max-width: 970px)': {
          fontSize: '70%',
        },
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          {loadingg ? (
            <Skeleton animation="wave" variant="circular" width={60} height={60} />
          ) : (
            <FontAwesomeIcon icon={faCircleUser} style={{ fontSize: '3.5rem' }} />
          )}
        </Grid>
        <Grid item xs>
          {loadingg ? (
            <Skeleton animation="wave" variant="rectangular" width="100%" height={50} />
          ) : (
            <Box>
              <Typography variant="h6" color="textPrimary">
                {me?.name?.toUpperCase()}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {me?.email}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {me?.phone}
              </Typography>
              <Button
             variant="text"
                color="error"
                size="small"
                onClick={handleOpen}
                sx={{
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                }}
              >
                Change Password
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Password Change Dialog */}
      <Dialog open={open} onClose={handleClose}   TransitionComponent={Slide} TransitionProps={{timeout:200}}>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Old Password"
            type={showOldPassword ? 'text' : 'password'}
            fullWidth
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => togglePasswordVisibility(setShowOldPassword)}
                  >
                    {showOldPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="New Password"
            type={showNewPassword ? 'text' : 'password'}
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => togglePasswordVisibility(setShowNewPassword)}
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="dense"
            label="Confirm New Password"
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => togglePasswordVisibility(setShowConfirmPassword)}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
        { passLoader ?  <div className='p-2 mr-4'> 
     <ThreeDots
     visible={true}
     height="40"
     width="40"
     color="#4fa94d"
     radius="9"
     ariaLabel="three-dots-loading"
     wrapperStyle={{}}
     wrapperClass=""
     />
     </div> :  <Button onClick={handleChangePassword} color="primary">
            Change Password
          </Button>}
        </DialogActions>
      </Dialog>
    </Paper>

    <Paper
      elevation={8}
      sx={{
        width: '100%',
        marginTop: 3,
        padding: 2,
        borderRadius: 4,
        position: 'relative',
        backgroundColor: 'white',
        '@media (min-width: 970px)': {
          width: '40%',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h6" color="textPrimary">
            Two-Factor Authentication
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {mfaStatusLoading ? 'Checking MFA status...' : mfaEnabled ? 'Enabled for this account' : 'Not enabled'}
          </Typography>
          {mfaEnabledAt && (
            <Typography variant="caption" color="textSecondary">
              Enabled on {new Date(mfaEnabledAt).toLocaleString()}
            </Typography>
          )}
        </Box>
        <Button
          variant="outlined"
          color={mfaEnabled ? "error" : "primary"}
          size="small"
          disabled={mfaStatusLoading || mfaSetupLoading}
          onClick={mfaEnabled ? () => setMfaDisableOpen(true) : handleStartMfaSetup}
        >
          {mfaEnabled ? "Disable MFA" : mfaSetupLoading ? "Starting..." : "Enable MFA"}
        </Button>
      </Box>
      {!mfaEnabled && !mfaStatusLoading && (
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          MFA is mandatory. Enable TOTP before continuing to use this account.
        </Typography>
      )}

      {mfaEnabled && !mfaStatusLoading && (
        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e5e7eb' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <Box>
              <Typography variant="subtitle2" color="textPrimary">
                Recovery Codes
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {mfaRecoveryStatus?.remaining ?? 0} of {mfaRecoveryStatus?.total ?? 0} remaining
              </Typography>
              <Typography variant="caption" color="textSecondary">
                Use these if you lose access to your authenticator phone.
              </Typography>
            </Box>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => setMfaRegenerateOpen(true)}
            >
              Regenerate Codes
            </Button>
          </Box>
        </Box>
      )}
    </Paper>

    <Dialog open={mfaSetupOpen} onClose={handleMfaSetupClose} TransitionComponent={Slide} TransitionProps={{timeout:200}} maxWidth="xs" fullWidth>
      <DialogTitle>Enable Two-Factor Authentication</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Scan this QR code in Google Authenticator or Microsoft Authenticator, then enter the 6-digit code.
        </Typography>

        {mfaSetupData?.qrCodeDataUrl && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img
              src={mfaSetupData.qrCodeDataUrl}
              alt="MFA setup QR code"
              style={{ width: 180, height: 180, borderRadius: 8 }}
            />
          </Box>
        )}

        {mfaSetupData?.manualKey && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ display: 'block', wordBreak: 'break-all', mb: 2 }}
          >
            Manual key: {mfaSetupData.manualKey}
          </Typography>
        )}

        <TextField
          margin="dense"
          label="6-digit authenticator code"
          fullWidth
          value={mfaSetupCode}
          onChange={(e) => setMfaSetupCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleMfaSetupClose} color="error" disabled={mfaSetupVerifyLoading}>
          Cancel
        </Button>
        {mfaSetupVerifyLoading ? <div className='p-2 mr-4'>
          <ThreeDots
            visible={true}
            height="40"
            width="40"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div> : <Button onClick={handleVerifyMfaSetup} color="primary">
          Enable MFA
        </Button>}
      </DialogActions>
    </Dialog>

    <Dialog open={recoveryCodesOpen} onClose={handleRecoveryCodesClose} TransitionComponent={Slide} TransitionProps={{timeout:200}} maxWidth="xs" fullWidth>
      <DialogTitle>Save Recovery Codes</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          {mfaRecoveryDialogMessage || 'Save these recovery codes now. Each code can be used only once.'}
        </Typography>
        <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, backgroundColor: '#f8fafc' }}>
          {plainRecoveryCodes.map((code) => (
            <Typography key={code} variant="body2" sx={{ fontFamily: 'monospace', letterSpacing: 1, mb: 0.5 }}>
              {code}
            </Typography>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={copyRecoveryCodes} color="primary">
          Copy Codes
        </Button>
        <Button onClick={handleRecoveryCodesClose} color="primary" variant="contained">
          I Have Saved Them
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={mfaRegenerateOpen} onClose={handleMfaRegenerateClose} TransitionComponent={Slide} TransitionProps={{timeout:200}}>
      <DialogTitle>Regenerate Recovery Codes</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          This will invalidate all previous recovery codes. Enter your current password and authenticator code.
        </Typography>
        <TextField
          margin="dense"
          label="Current Password"
          type={showMfaRegeneratePassword ? 'text' : 'password'}
          fullWidth
          value={mfaRegeneratePassword}
          onChange={(e) => setMfaRegeneratePassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowMfaRegeneratePassword((show) => !show)}>
                  {showMfaRegeneratePassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="dense"
          label="6-digit authenticator code"
          fullWidth
          value={mfaRegenerateCode}
          onChange={(e) => setMfaRegenerateCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleMfaRegenerateClose} color="error" disabled={mfaRegenerateLoading}>
          Cancel
        </Button>
        {mfaRegenerateLoading ? <div className='p-2 mr-4'>
          <ThreeDots
            visible={true}
            height="40"
            width="40"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div> : <Button onClick={handleRegenerateRecoveryCodes} color="primary">
          Regenerate Codes
        </Button>}
      </DialogActions>
    </Dialog>

    <Dialog open={mfaDisableOpen} onClose={handleMfaDisableClose} TransitionComponent={Slide} TransitionProps={{timeout:200}}>
      <DialogTitle>Disable Two-Factor Authentication</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Enter your current password and authenticator code to disable MFA.
        </Typography>
        <TextField
          margin="dense"
          label="Current Password"
          type={showMfaPassword ? 'text' : 'password'}
          fullWidth
          value={mfaPassword}
          onChange={(e) => setMfaPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowMfaPassword((show) => !show)}>
                  {showMfaPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="dense"
          label="6-digit authenticator code"
          fullWidth
          value={mfaCode}
          onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleMfaDisableClose} color="error">
          Cancel
        </Button>
        {mfaDisableLoading ? <div className='p-2 mr-4'>
          <ThreeDots
            visible={true}
            height="40"
            width="40"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div> : <Button onClick={handleDisableMfa} color="primary">
          Disable MFA
        </Button>}
      </DialogActions>
    </Dialog>




     { employee?.role==='admin' && <> 
  
        <div className="row mt-3">
          {/* button  and heading */}

          <div className="flex justify-between mb-2">
            <h1 className="h5 mb-3 text-gray-800 justify-content">
              Manage Master Datas
            </h1>
          </div>

          <div className="col-sm-12">
            {/* user tabs */}
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="country-tab"
                  data-toggle="tab"
                  data-target="#country"
                  type="button"
                  role="tab"
                  aria-controls="country"
                  aria-selected="true"
                  
                >
                  Currency List
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="currency-tab"
                  data-toggle="tab"
                  data-target="#currency"
                  type="button"
                  role="tab"
                  aria-controls="currency"
                  aria-selected="false"
                >
                  Currency List
                </button>
              </li> */}
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="product-tab"
                  data-toggle="tab"
                  data-target="#product"
                  type="button"
                  role="tab"
                  aria-controls="product"
                  aria-selected="false"
                >
                  Country List
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="qualityCategory-tab"
                  data-toggle="tab"
                  data-target="#qualityCategory"
                  type="button"
                  role="tab"
                  aria-controls="qualityCategory"
                  aria-selected="false"
                >
                  Quality Category
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="timeZone-tab"
                  data-toggle="tab"
                  data-target="#timeZone"
                  type="button"
                  role="tab"
                  aria-controls="timeZone"
                  aria-selected="false"
                >
                  Time Zone
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="paymentCycle-tab"
                  data-toggle="tab"
                  data-target="#paymentCycle"
                  type="button"
                  role="tab"
                  aria-controls="paymentCycle"
                  aria-selected="false"
                >
                  Payment Cycle
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="empGroup-tab"
                  data-toggle="tab"
                  data-target="#empGroup"
                  type="button"
                  role="tab"
                  aria-controls="empGroup"
                  aria-selected="false"
                >
                  NOC Manager Group
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="destination-tab"
                  data-toggle="tab"
                  data-target="#destination"
                  type="button"
                  role="tab"
                  aria-controls="destination"
                  aria-selected="false"
                >
                  Destination
                </button>
              </li>

            </ul>

            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active bg-transparent"
                id="country"
                role="tabpanel"
                aria-labelledby="country-tab"
              >
                <div className="col-sm-12">
                  
                  <Currency />
                </div>
              </div>
           

              <div
                className="tab-pane fade bg-transparent mt-3"
                id="product"
                role="tabpanel"
                aria-labelledby="product-tab"
              >
                <div className="col-sm-12 mt-3 ">
                  <Country />
                </div>
              </div>

              <div
                className="tab-pane fade bg-transparent mt-3"
                id="qualityCategory"
                role="tabpanel"
                aria-labelledby="qualityCategory-tab"
              >
                <div className="col-sm-12 mt-3 ">
                  <QualityCategory />
                </div>
              </div>

              <div
                className="tab-pane fade bg-transparent mt-3"
                id="timeZone"
                role="tabpanel"
                aria-labelledby="timeZone-tab"
              >
                <div className="col-sm-12 mt-3 ">
                  <TimeZone />
                </div>
              </div>

              <div
                className="tab-pane fade bg-transparent mt-3"
                id="paymentCycle"
                role="tabpanel"
                aria-labelledby="paymentCycle-tab"
              >
                <div className="col-sm-12 mt-3 ">
                  <PaymentCycle />
                </div>
              </div>

              <div
                className="tab-pane fade bg-transparent mt-3"
                id="empGroup"
                role="tabpanel"
                aria-labelledby="empGroup-tab"
              >
                <div className="col-sm-12 mt-3  text-black ">
                  <EmployeeGroupCompo/>
                </div>
              </div>


              <div
                className="tab-pane fade bg-transparent mt-3"
                id="destination"
                role="tabpanel"
                aria-labelledby="destination-tab"
              >
                <div className="col-sm-12 mt-3  text-black ">
                  <Destination/>
                </div>
              </div>



            </div>
          </div>
        </div>
        <br></br>
        <br></br> <hr></hr> <br></br>
        <br></br>


        {/* EMPLOYEE MANAGE */}


        {/* MANAGE USERS SECTION */}
        <div className="row">
          {/* button  and heading */}

          <div className="flex justify-between mb-2">
            <h1 className="h5 mb-4 text-gray-800 justify-content">
              Manage Employees
            </h1>
          </div>

          <div className="col-sm-12">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  data-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  All Employee
                </button>
              </li>
            </ul>

            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active bg-white "
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <EmployeeCompo />
              </div>
            </div>


          </div>
        </div>
        </>}
      </div>
     
    </Sidebar>
  );
};

export default Customer;
